import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.scss'],
})
export class ProfilePictureComponent implements OnInit {
  @Input() url: string = '../../../../assets/images/user.png';
  @Input() height: number = 50;
  @Input() width: number = 50;
  @Input() gender: string;

  @ViewChild('profileImage') profileImage: ElementRef<HTMLImageElement>;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {

    if (this.url == undefined || this.url == '' || this.url == null) {
      this.url = '../../../../assets/images/user.png';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.url && !changes.url.firstChange) {
      const newUrl = changes.url.currentValue || this.getDefaultImage();
      this.updateImageUrl(newUrl);
    }
  }

  updateImageUrl(url: string): void {
    if (this.profileImage && this.profileImage.nativeElement) {
      this.profileImage.nativeElement.src = url;
      this.cdr.detectChanges();  // Принудительно запускаем процесс обнаружения изменений
    }
  }

  errorHandler(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.getDefaultImage();
  }

  private getDefaultImage(): string {
    if (this.gender === 'MALE') {
      return '../../../../assets/images/male.png';
    } else if (this.gender === 'FEMALE') {
      return '../../../../assets/images/female.png';
    } else {
      return '../../../../assets/images/user.png';
    }
  }
}
